<div id="contenitore-cus-sat">
  <div class="card" id="cus-sat-card" [ngStyle]="{ 'background-color' : reviewDone ? '#29abe2' : 'white'}">
    <div class="card-body cus-sat-card-body">
      <div class="cus-sat-content px-3"
        [ngStyle]="{ 'visibility' : reviewVote ? 'visible'  : 'hidden', 'opacity' : reviewVote ? '1'  : '0', 'height' : reviewVote ? '100%'  : '0' }">
        <h5>Aiutaci a migliorare</h5>
        <h6 class="pb-2">Hai trovato utili le nostre informazioni?</h6>

        <div class="icons-container px-1">
          <div class="d-flex icon-container like" (click)="makeChoice(true)">
            <i class="fas fa-thumbs-up"></i>
          </div>
          <div class="d-flex icon-container dislike" (click)="makeChoice(false)">
            <i class="fas fa-thumbs-down"></i>
          </div>
        </div>
      </div>
      <form [formGroup]="form" role="form">
        <div class="review-content"
          [ngStyle]="{ 'visibility' : reviewBox ? 'visible'  : 'hidden', 'opacity' : reviewBox ? '1'  : '0', 'height' : reviewBox ? '100%'  : '0' }">
          <strong>Grazie per il feedback!</strong>
          <br>
          <span>Aiutaci a migliorare</span>
          <br>
          <label for="sezioni-visitate" style="padding-top: 15px; margin-bottom: .2rem !important;">
            Sezioni Visitate *
          </label>

          <div class="d-flex flex-column">
            <fieldset
              style="font-size: 0.8rem; font-weight: 400; font-family: Roboto; color: #4b4b4b; text-align: left; display: inline-grid">
              <label>
                <input type="checkbox" required formControlName="visitBollettini" value="visitBollettini">Previsioni Meteo</label>
              <label>
                <input type="checkbox" required formControlName="visitMeteo" value="visitMeteo"> Dati</label>
              <label>
                <input type="checkbox" required formControlName="visitAltro" value="visitAltro">Altro</label>
            </fieldset>
          </div>
          <br>
          <span>Puoi lasciare qui un tuo suggerimento</span>
          <textarea style="margin-top:10px; width: 100%;" placeholder="Scrivi qui il tuo suggerimento..."
            id="suggestion" formControlName="suggestion" name="suggestion" #suggestion></textarea>

          <button class="icon-send-review"
            [disabled]="form.controls['visitBollettini'].value == '' && form.controls['visitMeteo'].value == '' && form.controls['visitAltro'].value == ''"
            (click)="sendReview()">
            <i class="fas fa-angle-right"></i>
          </button>
        </div>
        <div class="review-content"
          [ngStyle]="{ 'visibility' : reviewName ? 'visible'  : 'hidden', 'opacity' : reviewName ? '1'  : '0', 'height' : reviewName ? '100%'  : '0' }">

          <p style="font-size: 11px; color: #6f6f6f;">Attenzione: i dati inseriti sono richiesti esclusivamente per
            finalità statistiche e non saranno utilizzati in alcun modo per scopi promozionali e/o commerciali</p>

          <div class="d-flex flex-column">
            <label for="nomeCognome" style="padding-top: 15px; margin-bottom: .2rem !important;">Nome e Cognome</label>
            <input id="nomeCognome" req formControlName="nomeCognome" type="text" name="nomeCognome"
              style="width: 100%">
            <label for="email" style="padding-top: 15px; margin-bottom: .2rem !important;">Email *</label>
            <input id="email" formControlName="email" required type="email" name="email" style="width: 100%">
          </div>
          <button class="icon-send-review" [disabled]="form.controls['email'].value == ''" (click)="sendName()">
            <i class="fas fa-angle-right"></i>
          </button>
        </div>
      </form>
      <div class="review-done"
        [ngStyle]="{ 'visibility' : reviewDone ? 'visible'  : 'hidden', 'opacity' : reviewDone ? '1'  : '0', 'height' : reviewDone ? '100%'  : '0' }">
        <strong>La tua opinione è preziosa, grazie!</strong>
      </div>
    </div>
    <span *ngIf="showCloseBtn" class="close-button-cus-sat" (click)="closeCusSatBox()"><strong>X</strong></span>
  </div>
</div>